// @flow

/* eslint-disable react-hooks/exhaustive-deps */

import * as React from 'react';

export const useClientPosition = <T: string>(
  targetRef: {| current: React.ElementRef<T> |},
  open: boolean,
  onClientPositionChange: () => void,
) => {
  const onChange = React.useRef(null);
  onChange.current = onClientPositionChange;

  React.useEffect(() => {
    onClientPositionChange();
  }, []);

  React.useEffect(() => {
    // listen to scroll only when popup is open
    if (open) {
      const handleScroll = event => {
        // ignore scroll events from siblings
        if (event.target.contains(targetRef.current) && onChange.current) {
          onChange.current();
        }
      };

      // listen window resize too
      const handleResize = () => {
        if (onChange.current) {
          onChange.current();
        }
      };

      // enable capture to listen scroll events of all elements
      const scrollOptions = true;

      if (onChange.current) {
        onChange.current();
      }
      window.addEventListener('scroll', handleScroll, scrollOptions);
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('scroll', handleScroll, scrollOptions);
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [open]);
};
